import { createStatefulApiClient } from '@hprofits/api-client';
import { isEmpty } from '@hprofits/utils/fp/optional';

import * as config from '@/../config/index.js';
import { getAuthSession } from '@/auth/session';
import { readSessionRole } from '@/auth/tabStorage';
import { normalizeAdnetApiHost } from '@/utils/adnetHost';

import { createLegacyTokenStorage } from './storage';

const KEY_PREFIX = 'hp';

const backendApiHost = normalizeAdnetApiHost(process.env.BACKEND_API_HOST);

const getActiveRoleHeader = (): Record<string, string> => {
  const roleName = readSessionRole();
  if (!roleName) {
    return {};
  }
  const roleId = config.default.rolesIds[roleName as keyof typeof config.default.rolesIds];
  if (isEmpty(roleId)) {
    return {};
  }
  return { 'X-ACTIVE-ROLE-ID': String(roleId) };
};

// OpenAPILink requires an absolute URL for the URL() constructor.
// When running behind a dev proxy (ADNET_API_HOST=/), adnetApiHost is empty —
// use window.location.origin to make the URL absolute.
const apiBaseURL = backendApiHost ? `${backendApiHost}/api/` : `${window.location.origin}/api/`;

export const apiClient = createStatefulApiClient({
  baseURL: apiBaseURL,
  storage: createLegacyTokenStorage(KEY_PREFIX),
  keyPrefix: KEY_PREFIX,
  externalRefresh: () => getAuthSession().refresh(),
  headers: getActiveRoleHeader,
});
